class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    // Handle close button clicks within this component
    this.addEventListener('click', (evt) => {
      if (evt.target.matches('.mobile-menu__close') || evt.target.closest('.mobile-menu__close')) {
        evt.preventDefault();
        this.close();
      }
      
      if (evt.target.matches('.mobile-menu__overlay')) {
        this.close();
      }
    });

    document.addEventListener('keydown', (evt) => {
      if (evt.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.classList.add('mobile-menu--open');
    document.body.classList.add('mobile-menu-open');
    this.lockBodyScroll();
  }

  close() {
    this.isOpen = false;
    this.classList.remove('mobile-menu--open');
    document.body.classList.remove('mobile-menu-open');
    this.unlockBodyScroll();
  }

  lockBodyScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  unlockBodyScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu);
}